import React, { useContext } from 'react';

const modalScrollContext = React.createContext();
const modalScrollUpdateContext = React.createContext();

export function useModalScroll() {
    return useContext(modalScrollContext);
}
export function useModalScrollUpdate() {
    return useContext(modalScrollUpdateContext);
}


export function MixProvider({ children }) {
    
    const [modalScroll,setModalScroll] = React.useState(true);

    function setModScroll(_index) {
        setModalScroll(_index);
    } 
    
    return (
        <modalScrollContext.Provider value={modalScroll}>
            <modalScrollUpdateContext.Provider value={setModScroll}>
                {children}
            </modalScrollUpdateContext.Provider>
        </modalScrollContext.Provider>          
    )
}
